import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
	selector: 'lvr-admin',
	templateUrl: './admin.html',
	imports: [RouterOutlet],
})
export class Admin {}
